import { GlobalContent, content as globalContent } from "./global.content";
import {
  AboutPageContent,
  content as aboutContent,
} from "./pages/about.content";
import {
  ContactUsPageContent,
  content as contactUsContent,
} from "./pages/contact-us.content";
import {
  LandingContent,
  content as landingContent,
} from "./pages/landing.content";
import {
  TalentByProfessionContent,
  content as tbpContent,
} from "./pages/talent-by-profession.content";
import {
  TalentBySpecialityContent,
  content as tbsContent,
} from "./pages/talent-by-specialty.content";

interface ContentStore {
  global: GlobalContent;
  pages: {
    about: AboutPageContent;
    contactUs: ContactUsPageContent;
    landing: LandingContent;
    talentByProfession: TalentByProfessionContent;
    talentBySpecialty: TalentBySpecialityContent;
  };
}

const contentStore: ContentStore = {
  global: globalContent,
  pages: {
    about: aboutContent,
    contactUs: contactUsContent,
    landing: landingContent,
    talentByProfession: tbpContent,
    talentBySpecialty: tbsContent,
  },
};

export default contentStore;
